import { FC } from "react";
import { Spin } from "antd";

export const CustomFormSubmissionsLoading: FC = () => {
  return <Spin />;
};
